// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_VerificarRunInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract de POST /migration/franquias/verificar
 * (controllers/migration/franquias.php::verificar).
 *
 * UM campo: qual execucao verificar.
 *
 * ---------------------------------------------------------------------------
 * POR QUE NO CORPO, E NAO NA URL
 * ---------------------------------------------------------------------------
 * Mesma escolha de `migrar` (que recebe o `zoho_id` no corpo) e pelo mesmo
 * motivo: o corpo passa por um InputContract, e o contrato e o unico lugar onde
 * a recusa de um pedido malformado esta PROVADA por teste. Um id no segmento da
 * URL seria coagido por `(int)` — `'abc'` viraria 0, o endpoint verificaria a
 * execucao zero e responderia "nao encontrado", que e uma mentira sobre o que
 * foi pedido.
 *
 * O piso e 1 e nao 0 porque `migration_runs.id` e AUTO_INCREMENT: nao existe
 * execucao zero, e aceita-la so produziria um erro pior mais adiante.
 */
import { registerContract } from './validate'

export interface Migration_VerificarRunInput {
run_id?: number
}

registerContract('Migration_VerificarRunInput', {
  run_id: { type: 'number',  required: false },
})
